import { useLocation } from 'react-router-dom'
import { useEffect } from 'react'
import { ExtendedWindow } from './matomo.define.ts'
import { useSelector } from 'react-redux'
import { selectUser } from '../features/user/user.slice.ts'

export function useMatomoTrack() {
  const location = useLocation()
  const user = useSelector(selectUser)
  useEffect(() => {
    const eWindow = window as ExtendedWindow
    // Initialize _paq if not present
    if (!eWindow._paq) {
      eWindow._paq = []
    }
    const _paq = eWindow._paq

    if (user?.email) {
      _paq.push(['setUserId', user.email])
    }

    _paq.push(['trackPageView'])
    _paq.push(['enableLinkTracking'])

    const u = 'https://polymercapital.matomo.cloud/'
    _paq.push(['setTrackerUrl', u + 'matomo.php'])
    _paq.push(['setSiteId', '3'])

    // Inject Matomo script only if not already present
    if (!document.querySelector('script[src*="matomo.js"]')) {
      const g = document.createElement('script')
      g.async = true
      g.src = 'https://cdn.matomo.cloud/polymercapital.matomo.cloud/matomo.js'
      const s = document.getElementsByTagName('script')[0]
      s?.parentNode?.insertBefore(g, s)
    }
  }, [location])
}
